import { render, staticRenderFns } from "./Deny.vue?vue&type=template&id=8dda107e&scoped=true"
import script from "./Deny.vue?vue&type=script&lang=ts"
export * from "./Deny.vue?vue&type=script&lang=ts"
import style0 from "./Deny.vue?vue&type=style&index=0&id=8dda107e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dda107e",
  null
  
)

export default component.exports